export default defineNuxtRouteMiddleware((to, from) => {
  // On Each Router Navigation, If keepalive meta does not exist,
  // Clear all errors from state.
  if (!from.meta || !from.meta.keepalive) {
    const errors = useErrors();
    errors.value = { message: "", errors: [] };
  }
});
